exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StatisticItem__container___wjI3e {\n  position: relative;\n  display: block;\n  height: 25px;\n  width: 250px; }\n\n.StatisticItem__value___igIp4 {\n  color: #428BCD;\n  border-radius: 50%;\n  padding: 1px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  display: inline-block; }\n\n.StatisticItem__title___Hio2_ {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0; }\n", ""]);

// exports
exports.locals = {
	"container": "StatisticItem__container___wjI3e",
	"value": "StatisticItem__value___igIp4",
	"title": "StatisticItem__title___Hio2_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/UserProfilePage/styles/StatisticItem.scss
// module id = 4872
// module chunks = 6